
import { computed, defineComponent, PropType } from 'vue'

import Cheap from '@/common/components/UI/Cheap/index.vue'
import Loader from '@/common/components/UI/Loader/index.vue'
import { BillingCalculateCostResponseAdditionalServices } from '@/core/types/billing.types'

const TARIFFS = {
    1: 'Стандартный тариф',
    2: 'Индивидуальный тариф',
    3: 'Уникальный тариф',
}

export default defineComponent({
    components: {
        Cheap,
        Loader,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        fromCityName: {
            type: String,
            default: null,
        },
        whereCityName: {
            type: String,
            default: null,
        },
        isHasPickup: {
            type: Boolean,
            default: false,
        },
        isHasSelfDelivery: {
            type: Boolean,
            default: false,
        },
        cost: {
            type: Number,
            default: 0,
        },
        days: {
            type: Number,
            default: 0,
        },
        insuranceCost: {
            type: Number,
            default: 0,
        },
        packagingCost: {
            type: Number,
            default: 0,
        },
        unloadCost: {
            type: Number,
            default: 0,
        },
        tariffId: {
            type: Number,
            default: 1,
        },
        usedWeightInKg: {
            type: Number,
            default: 0,
        },
        weightTypeToCalculate: {
            type: [String, null] as PropType<string | null>,
            default: null,
        },
        shipmentTypeId: {
            type: Number,
            default: 1,
        },
        isCitiesEquals: {
            type: Boolean,
            default: false,
        },
        declaredPrice: {
            type: [Number, null] as PropType<number | null>,
            default: null,
        },
        productName: {
            type: [String, null] as PropType<string | null>,
            default: null,
        },
        additionalServiceDelivery: {
            type: Object as PropType<BillingCalculateCostResponseAdditionalServices>,
            default: null,
        },
        additionalServiceTake: {
            type: Object as PropType<BillingCalculateCostResponseAdditionalServices>,
            default: null,
        },
        isFtl: {
            type: Boolean,
            default: false,
        },
        finalCost: {
            type: Number,
            default: 0,
        },
        deliveryCharge: {
            type: Number,
            default: 0,
        },
        deliveryCost: {
            type: Number,
            default: 0,
        },
        downtimeCost: {
            type: Number,
            default: 0,
        },
        vatCoefficient: {
            type: Number,
            default: 0,
        },
    },
    setup(props) {
        const isShowMessageCityEquals = computed(() => {
            if (props.shipmentTypeId === 2 && props.isCitiesEquals) return true
            return false
        })

        const isCanRenderAdditionalServiceDelivery = computed(() => {
            if (
                props.additionalServiceDelivery &&
                (props.additionalServiceDelivery.craneCost ||
                    props.additionalServiceDelivery.gridCost ||
                    props.additionalServiceDelivery.hydraulicTrolleyCost ||
                    props.additionalServiceDelivery.loaderCost ||
                    props.additionalServiceDelivery.manipulatorCost ||
                    props.additionalServiceDelivery.palletCost ||
                    props.additionalServiceDelivery.softPackageCost)
            ) {
                return true
            }

            return false
        })

        return { TARIFFS, isShowMessageCityEquals, isCanRenderAdditionalServiceDelivery }
    },
})
